import React from "react"
import { IQueryBuilderContext } from "@types"

export const QueryBuilderContext = React.createContext<IQueryBuilderContext | null>(null)